import React from 'react';
import { Card, SectionHead } from '../../shared/ui';

interface FormSectionProps {
  n: number;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

// Cartão numerado da coluna do formulário (1 Emitente, 2 Tomador…).
export function FormSection({ n, title, subtitle, children }: FormSectionProps) {
  const id = `secao-${n}`;
  return (
    <Card as="section" aria-labelledby={id} p={6} overflow="visible">
      <SectionHead n={n} id={id} title={title} description={subtitle} />
      {children}
    </Card>
  );
}
